var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.fade ? "fade" : "" } }, [
    !_vm.closed
      ? _c("div", { class: _vm.wrapClasses }, [
          _vm.showIcon
            ? _c(
                "span",
                { class: _vm.iconClasses },
                [
                  _vm._t("icon", function() {
                    return [_c("Icon", { attrs: { type: _vm.iconType } })]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("span", { class: _vm.messageClasses }, [_vm._t("default")], 2),
          _vm._v(" "),
          _c("span", { class: _vm.descClasses }, [_vm._t("desc")], 2),
          _vm._v(" "),
          _vm.closable
            ? _c(
                "a",
                { class: _vm.closeClasses, on: { click: _vm.close } },
                [
                  _vm._t("close", function() {
                    return [_c("Icon", { attrs: { type: "ios-close" } })]
                  })
                ],
                2
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b8e90282", { render: render, staticRenderFns: staticRenderFns })
  }
}